/** Pulse document+timeline mark. Decorative when inside a labeled button. */
export default function PulseIcon({ size = 36 }: { size?: number }) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 40 40"
      width={size}
      height={size}
      fill="none"
      stroke="currentColor"
      strokeWidth="1.65"
      strokeLinecap="round"
      strokeLinejoin="round"
      aria-hidden="true"
    >
      <path d="M19 7H9a2 2 0 0 0-2 2v22a2 2 0 0 0 2 2h20a2 2 0 0 0 2-2V19L19 7Z" />
      <path d="M19 7v10a2 2 0 0 0 2 2h10M13 16v11M17 23h7M17 28h7" />
      <circle cx="13" cy="16" r="1.5" fill="currentColor" stroke="none" />
      <circle cx="13" cy="22" r="1.5" fill="currentColor" stroke="none" />
      <circle cx="13" cy="28" r="1.5" fill="currentColor" stroke="none" />
    </svg>
  )
}
